module.exports = __webpack_public_path__ + "static/media/info.faea1077.svg";